<div class="overview-pagination">
  <div class="overview-pagination__nav">
    <button
      type="button"
      class="overview-pagination__btn"
      [disabled]="atFirstPage()"
      (click)="prev()"
      [attr.aria-label]="'common.pagination.prev' | translate"
    >
      <mat-icon aria-hidden="true">chevron_left</mat-icon>
    </button>
    <span role="status">
      {{ 'common.pagination.info' | translate: { start: pageStart(), end: pageEnd(), total: totalCount() } }}
    </span>
    <button
      type="button"
      class="overview-pagination__btn"
      [disabled]="atLastPage()"
      (click)="next()"
      [attr.aria-label]="'common.pagination.next' | translate"
    >
      <mat-icon aria-hidden="true">chevron_right</mat-icon>
    </button>
  </div>
  <div class="overview-pagination__size">
    <span>{{ 'common.pagination.rowsPerPage' | translate }}</span>
    <select
      #sizeSelect
      class="overview-pagination__select"
      (change)="onSizeChange(+sizeSelect.value)"
      [attr.aria-label]="'common.pagination.rowsPerPageAria' | translate"
    >
      @for (option of pageSizeOptions(); track option) {
        <option [value]="option" [selected]="pageSize() === option">{{ option }}</option>
      }
    </select>
  </div>
</div>
